import { helper } from "lib/helper";
import usersModel from "models/users.model";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Button, Card, CardHeader, Container, Row, Table } from "reactstrap";

const TransactionDetails = ({ user, isLoading }) => {
  const { id } = useParams();
  const location = useLocation();
  const [transactions, setTransactions] = useState([])

  const getTransactionsDetails = async () => {
    await usersModel
      .transactionsDetails(id)
      .then((result) => {
        if (result) {
          console.log(result)
          console.log(result?.data?.transactions);
          setTransactions(result?.data?.transactions);
        }
      })
      .catch((error) => {
        console.log(error);
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  const handleDelete = async (id) => {
    const result = await helper.sweetalert.confirm(
      "Are you sure you want to delete this transaction?",
      "info",
      true
    );
    if (result.isConfirmed) {
      try {
        await usersModel.deleteTransaction(id);
        const updatedList = transactions.filter((item) => item._id !== id);
        setTransactions(updatedList);
        helper.sweetalert.toast("Transaction deleted successfully!");
      } catch (error) {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      } 
    }
  };

  useEffect(() => {
    getTransactionsDetails();
  }, [location]);

  return (
    <Container className="">
        {!isLoading &&  transactions.length < 1 ? <h3 className="text-center">No Transaction found</h3> :  (
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">User Transactions</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Reference Id</th>
                    <th scope="col">Account Holder Name</th>
                    <th scope="col">Bank Name</th>
                    <th scope="col">Price</th>
                    <th scope="col">Experience Time</th>
                    {/* <th scope="col">Experience Date</th> */}
                    <th scope="col">Mode</th>
                    <th scope="col">Booked Status</th>
                    <th scope="col">Refund Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.map((transaction, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{transaction?.referenceId}</td>
                      <td>{transaction?.holderName}</td>
                      <td>{transaction?.bank}</td>
                      <td>{(transaction?.amount)?.toFixed(0)}</td>
                      <td>{transaction?.booking?.startTime } - {transaction?.booking?.endTime}</td>
                      {/* <td>No Data</td> */}
                      <td>{transaction?.mode}</td>
                      <td>
                        {transaction?.status}
                      </td>
                      <td>
                        {transaction.refund ? "Refunded" : "Not Refunded"}
                      </td>
                      {/* <td>{transaction.interest}</td>
                      <td>{transaction.invitation ? "Yes" : "No"}</td>
                      <td>
                        {transaction.booked.status
                          ? transaction.booked.price
                          : "-"}
                      </td> */}
                      {/* <td>
                        {transaction.booked.status
                          ? `${transaction.booked.date} at ${transaction.booked.time}`
                          : "-"}
                      </td>
                       */}
                      <td>
                        {/* <Button
                          color="info"
                          size="sm"
                          className="mr-2"
                          // onClick={() => handleViewMore(index)}
                        >
                          <i className="fa-solid fa-eye"></i>
                        </Button>
                        <Button
                          color="warning"
                          size="sm"
                          className="mr-2"
                          // onClick={() => handleEdit(index)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button> */}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(transaction._id)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      )}
    </Container>
  );
};

export default TransactionDetails;
